import React from 'react';
import { useTranslation } from 'react-i18next';
import ExpandIcon from '@wix/da-ds/pkg/Icons/Expand';
import ShrinkIcon from '@wix/da-ds/pkg/Icons/Shrink';
import ActionBarIcon from '../../_partials/ActionBarIcon';
import { useDeviationViewContext } from '../../../Context';
import ActionBarItemWrapper from '../../_partials/items/ActionBarItemWrapper';
import ActionBarButton from '../../_partials/items/ActionBarButton';
export var ExpandButton = function (_a) {
    var canFullscreen = _a.canFullscreen, deviation = _a.deviation, onClick = _a.onClick;
    var t = useTranslation().t;
    var isFullscreen = useDeviationViewContext().isFullscreen;
    return (React.createElement(ActionBarItemWrapper, { tooltip: t("actionbar.".concat(isFullscreen ? 'regular' : 'expand', "View").concat(canFullscreen ? '' : '.disabled')) },
        React.createElement(ActionBarButton, { onClick: function () { return onClick(deviation); }, disabled: !canFullscreen },
            React.createElement(ActionBarIcon, { icon: isFullscreen ? ShrinkIcon : ExpandIcon }))));
};
ExpandButton.displayName = 'ExpandButton';
export default ExpandButton;
//# sourceMappingURL=ExpandButton.js.map